import React, { ChangeEvent, FocusEvent, Fragment } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Preloader from '../../../components/behavior/Preloader';
import {
  CheckIcon,
  DataProtectionText,
  InlinedSmallLabel,
  Input,
  Label
} from '../../../components/Form';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';

interface DataProtectionProps {
  value: boolean;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: FocusEvent) => void;
  error: boolean;
  codeLocation?: string;
}

export const DEFAULT_CODE_LOCATION = 'GWC';

const DataProtection = ({
  value,
  handleChange,
  handleBlur,
  error,
  // default location is Neu-Ulm
  codeLocation = DEFAULT_CODE_LOCATION,
  typo3: { fetchPrivacyInfo },
  location
}: DataProtectionProps & RouteComponentProps & WithTypo3Props) => (
  <Fragment>
    <DataProtectionText>
      <Preloader
        key={codeLocation}
        fetcher={() =>
          fetchPrivacyInfo({
            path: location.pathname,
            searchValue: codeLocation
          })
        }
        render={({ loading, data, error }) => {
          if (!loading && !error && data) {
            return <HtmlContent htmlString={data} />;
          }
          // TODO: show Spinner?
          return null;
        }}
      />
    </DataProtectionText>
    <Label checkbox>
      <Input
        inlined
        type="checkbox"
        name="dataprotection"
        error={error}
        checked={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <CheckIcon error={error} />
      <InlinedSmallLabel error={error} required>
        <Typo3Label label="form.label.dataProtection">
          Ja, ich willige in die Verarbeitung und Nutzung meiner Daten zur
          Bearbeitung meiner Anfrage ein.
        </Typo3Label>
      </InlinedSmallLabel>
    </Label>
  </Fragment>
);

export default withRouter(withTypo3(DataProtection));
